import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class UploadErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/UploadFiles\/UploadConstraints/,
      messages: {
        400: 'errors.getConstraintsFailed',
        404: 'errors.getConstraintsFailed',
        500: 'errors.getConstraintsFailed',
        success: {
          default: 'errors.getConstraintsFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
